import { defineComponent as _defineComponent } from 'vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { ExpoScaleEase } from 'gsap/EasePack';
import { gsap } from 'gsap';
import useIntersectionObserver from '@/composables/intersection-observer';
export default /*#__PURE__*/ _defineComponent({
    __name: 'intersect',
    props: {
        threshold: { type: Number, required: true },
        duration: { type: Number, required: true },
        delay: { type: Number, required: true },
        startingY: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        gsap.registerPlugin(ExpoScaleEase);
        const props = __props;
        const element = ref();
        const { intersectionObserver } = useIntersectionObserver();
        const options = {
            threshold: props.threshold,
        };
        onMounted(() => {
            if (!element.value)
                return;
            const timeline = gsap.timeline({
                paused: true,
            });
            timeline.to(element.value, {
                autoAlpha: 1,
                duration: props.duration,
                ease: 'expo.out',
                delay: props.delay,
                y: 0,
            });
            intersectionObserver.observe(element.value, options);
            intersectionObserver.addEnterCallback(element.value, () => {
                timeline.play();
            });
            intersectionObserver.addExitCallback(element.value, () => {
                timeline.reverse();
            });
        });
        onUnmounted(() => {
            if (!element.value)
                return;
            intersectionObserver.unobserve(element.value, options);
        });
        const __returned__ = { props, element, intersectionObserver, options };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
